// EmailJs account - nitin.navik@tarkashilpa.com
// export const EMAIL_USER_ID = "-AN-Eu3Gxhn2xnjBa"
// export const EMAIL_SERVICE_ID = "service_r2qubrr"
// export const EMAIL_TEMPLATE_ID = "template_j6cmhle"

//EmailJs production account.
export const EMAIL_USER_ID = "bRLofN4y5SlAu29R7"
export const EMAIL_SERVICE_ID = "service_gpwjd2j"
export const EMAIL_TEMPLATE_ID = "template_673kcnr"
